<template>
    <el-container class="wrapper">
        <el-aside class="navigation">
            <h1 class="title">프린팅공작소 <span>Admin</span></h1>
            <el-menu :router="true"
                     :default-active="$route.path"
                     background-color="#545c64"
                     text-color="#fff"
                     active-text-color="#ffd04b">
                <el-menu-item :index="routeNames.ROUTE_DASHBOARD"><i class="el-icon-menu"></i>대시보드</el-menu-item>
                <el-submenu :index="routeNames.ROUTE_USERS">
                    <template slot="title"><i class="el-icon-user"></i>유저 관리</template>
                    <el-menu-item-group>
                        <el-menu-item :index="routeNames.ROUTE_USERS">
                            <i class="el-icon-tickets"></i>유저 리스트
                        </el-menu-item>
                        <el-menu-item :index="routeNames.ROUTE_USERS_EDIT">
                            <i class="el-icon-edit"></i>유저 생성
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
                <el-submenu :index="routeNames.ROUTE_ARTS">
                    <template slot="title"><i class="el-icon-house"></i>작품 관리</template>
                    <el-menu-item-group>
                        <el-menu-item :index="routeNames.ROUTE_ARTS">
                            <i class="el-icon-tickets"></i>작품 리스트
                        </el-menu-item>
                        <el-menu-item :index="routeNames.ROUTE_ARTS_CREATE">
                            <i class="el-icon-edit"></i>작품 추가
                        </el-menu-item>
                    </el-menu-item-group>
                </el-submenu>
            </el-menu>
        </el-aside>

        <el-main>
            <slot></slot>
        </el-main>
    </el-container>
</template>

<script>
    import * as routeNames from '@/router/routeNames';

    export default {
        name: 'NavAndBody',
        data() {
            return {
                routeNames,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .wrapper {
        width: 100%;
        height: 100%;
    }

    .navigation {
        width: 260px;
        height: 100%;
        background-color: #545c64;

        .title {
            color: #fff;
            text-align: center;
            font-size: 22px;
            padding: 30px 0;

            span {
                color: #F56C6C;
                font-size: 14px;
            }
        }
    }

    .el-menu {
        border: 0;
    }
</style>